(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('mousetrap')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'mousetrap'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.reakeys = {}, global.react, global.Mousetrap));
}(this, (function (exports, react, Mousetrap) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var Mousetrap__default = /*#__PURE__*/_interopDefaultLegacy(Mousetrap);

  /**
   * Creates a global state singleton.
   */
  const createStateHook = () => {
      const mousetraps = new Map();
      let keys = [];
      const bindKeys = (nextKeys) => {
          nextKeys.forEach((k) => {
              if (k.disabled) {
                  return;
              }
              if (k.ref) {
                  if (!k.ref.current) {
                      // exit early if ref is provided but null
                      // we do not want to attach global event handlers in this case
                      return;
                  }
                  const element = k.ref.current;
                  if (!mousetraps.has(element)) {
                      mousetraps.set(element, new Mousetrap__default['default'](element));
                  }
                  mousetraps.get(element).bind(k.keys, k.callback, k.action);
              }
              else {
                  if (!mousetraps.get(undefined)) {
                      mousetraps.set(undefined, Mousetrap__default['default']);
                  }
                  mousetraps.get(undefined).bind(k.keys, k.callback, k.action);
              }
          });
      };
      const addKeys = (nextKeys) => {
          keys = [...keys, ...nextKeys];
          bindKeys(nextKeys);
      };
      const removeKeys = (nextKeys) => {
          // remove keys from the array
          keys = keys.filter((k) => !nextKeys.includes(k));
          // unbind mousetrap events
          nextKeys.forEach((k) => {
              var _a, _b;
              if (k.ref) {
                  if (!k.ref.current) {
                      return;
                  }
                  (_a = mousetraps.get(k.ref.current)) === null || _a === void 0 ? void 0 : _a.unbind(k.keys, k.action);
              }
              else {
                  (_b = mousetraps.get(undefined)) === null || _b === void 0 ? void 0 : _b.unbind(k.keys, k.action);
              }
          });
          // drop mousetrap instances that have no keys attached anymore
          for (const [element] of mousetraps) {
              if (element === undefined) {
                  if (keys.some((k) => k.ref === undefined)) {
                      continue;
                  }
              }
              else {
                  if (keys.some((k) => { var _a; return ((_a = k.ref) === null || _a === void 0 ? void 0 : _a.current) === element; })) {
                      continue;
                  }
              }
              mousetraps.delete(element);
          }
          // re-bind keys to restore listeners that were overwritten by the ones we just removed
          bindKeys(keys);
      };
      return () => {
          const [state, setState] = react.useState([]);
          react.useEffect(() => {
              setState(keys);
          }, []);
          return [state, addKeys, removeKeys];
      };
  };
  const useHotkeyState = createStateHook();

  const useHotkeys = (shortcuts) => {
      const [keys, addKeys, removeKeys] = useHotkeyState();
      react.useLayoutEffect(() => {
          if (shortcuts) {
              addKeys(shortcuts);
          }
          return () => {
              if (shortcuts) {
                  removeKeys(shortcuts);
              }
          };
      }, [shortcuts]);
      return react.useMemo(() => keys.reduce((agg, cur) => {
          if (!agg.find((a) => a.keys === cur.keys && a.ref && cur.ref)) {
              agg.push(cur);
          }
          return agg;
      }, []), [keys]);
  };

  let isMac = false;
  try {
      if (navigator)
          isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  }
  catch (e) {
  }
  const MODIFIER_KEY = isMac ? '⌘' : 'CTRL';
  function getHotkeyText(hotkey) {
      return hotkey
          .replace('modifier', MODIFIER_KEY)
          .replace('mod', MODIFIER_KEY)
          .replace('shift', '⇧');
  }

  exports.MODIFIER_KEY = MODIFIER_KEY;
  exports.getHotkeyText = getHotkeyText;
  exports.useHotkeyState = useHotkeyState;
  exports.useHotkeys = useHotkeys;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
